import { motion } from "framer-motion";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import ImageWithContentLeftForProduct from "@/components/elements/ImageWithContent/ImageWithContentLeftForProduct";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import Table from "@/components/elements/Table/Table";
import TitleBar from "@/components/elements/TitleBar/TitleBar";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import imgnotavailableImg from '@/assets/images/products/imgnotavailable.png';

const fadeInUp = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: false, amount: 0.2 },
};

const VistaIwa = () => {
  return (
    <div className="2xl:px-40 xl:px-40 md:px-[3rem] sm:px-5 my-[4rem] ">
      <TitleBar
        title="Vista IWA"
        subTitle="(Shotcrete Accelerator – Alkali Free)"
      />

      <motion.div {...fadeInUp}>
        <ImageWithContentLeftForProduct alt="Vista IWA"
          imageUrl={imgnotavailableImg}
          title="Description"
          content="Vista IWA (Dr. Vista 108 IWA+) is a unique, multipurpose, advanced technology integral waterproofing compound. It is made from specially formulated cement-friendly surface-active agents, corrosion-inhibiting additives, and polymers. Designed to be added to cement concrete, mortar, and plasters, Vista IWA enhances water resistance by sealing the concrete against capillary absorption and preventing water ingress."
        />
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Advantages">
          <CustomLists
            items={[
              [
                "Corrosion resistant",
                "Compatible with all varieties of Portland cement",
                "Minimizes rebound loss",
                "Improves workability of fresh concrete",
              ],
              [
                "Produces water-repellent concrete",
                "Prevents/reduces sweating, efflorescence, and saltpeter action",
                "Reduces shrinkage and provides better finish",
                "Economical with low dosage requirement",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Area of Application">
          <Paragraph content="Vista IWA is recommended for use in structural concrete, particularly in:" />
          <CustomLists
            items={[
              [
                "Basements",
                "Water tanks and water-retaining structures",
                "Bathrooms and balconies",
                "Repair and renovation work",
              ],
              [
                "Roof slabs and screeds",
                "Internal and external plastering",
                "Sumps and drains",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Properties">
          <Table
            items={{
              headings: [],
              rows: [
                ["Appearance", "Blue"],
                ["Color", "Dark Brown"],
                ["pH", "1.10 ± 0.02"],
                ["Chloride Content", "10 – 11"],
                ["Water Permeability", "60% of control mix"],
              ],
            }}
          />
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default VistaIwa;
